var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0447 52.0013C21.0859 51.5605 20.8127 50.7896 20.8391 49.778C20.8879 47.9001 20.833 46.0201 20.8686 44.1422C20.8767 43.7248 21.091 43.3134 21.1895 42.895C21.2274 42.731 21.2329 42.5613 21.2058 42.3953C21.0991 41.7493 20.8716 41.1064 20.8686 40.4655C20.8422 34.593 20.8483 28.7205 20.8554 22.847C20.8554 20.383 22.326 18.4289 24.5554 17.8815C27.7171 17.1045 30.5955 19.4111 30.6402 22.7708C30.6595 24.1928 30.6402 25.6147 30.6402 27.0366V27.6257C32.1464 27.6257 33.5977 27.6196 35.0491 27.6257C35.4711 27.6212 35.8929 27.6493 36.3105 27.71C38.5734 28.0807 40.2868 29.981 40.3264 32.2743C40.3762 35.1181 40.361 37.9619 40.3315 40.8058C40.3214 41.8214 39.7109 42.8269 40.3457 43.8365C40.3457 46.0201 40.3457 48.2034 40.3457 50.3864C40.3457 51.2365 39.8135 51.6895 39.1036 51.9993L22.0447 52.0013ZM24.1034 31.6415C24.1034 34.5531 24.1034 37.4646 24.1034 40.3761C24.1034 41.6152 24.7453 42.2521 25.9814 42.2521C29.0622 42.2521 32.143 42.2521 35.2238 42.2521C36.4822 42.2521 37.1017 41.6427 37.1038 40.3924C37.1038 37.837 37.1038 35.2816 37.1038 32.7263C37.1038 31.5075 36.4771 30.8788 35.2644 30.8778C33.2676 30.8778 31.2709 30.8778 29.2721 30.8778C28.0249 30.8778 27.3992 30.2562 27.3952 29.013C27.3952 26.999 27.3952 24.985 27.3952 22.9719C27.3985 22.7523 27.3828 22.5328 27.3484 22.3158C27.2855 21.9454 27.094 21.6091 26.8075 21.3661C26.521 21.1231 26.158 20.989 25.7823 20.9874C24.8012 20.9691 24.1105 21.7105 24.1085 22.8155C24.1004 25.7548 24.0987 28.6968 24.1034 31.6415ZM24.1288 48.7218H37.0642V45.5316H24.1288V48.7218Z",
    fill: "url(#paint0_linear_76_9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9198 0C27.2631 0.0761739 27.6074 0.147268 27.9486 0.230552C29.7968 0.689423 31.426 1.78112 32.5531 3.31606C33.6802 4.85099 34.2342 6.73222 34.1187 8.63304C33.8953 12.4671 30.9164 15.6593 27.0904 16.1661C22.7231 16.7451 18.5985 13.7022 17.9861 9.44049C17.328 4.86091 20.3221 0.758694 24.8103 0.0903945C24.9065 0.0685708 25.0007 0.0383218 25.0916 0H26.9198ZM25.9833 3.25009C25.0191 3.25452 24.0778 3.54479 23.2786 4.08419C22.4793 4.6236 21.858 5.38791 21.4931 6.28046C21.1282 7.17301 21.0363 8.15372 21.2288 9.09855C21.4213 10.0434 21.8897 10.9099 22.5747 11.5885C23.2597 12.2671 24.1306 12.7274 25.0772 12.911C26.0238 13.0947 27.0036 12.9935 27.8927 12.6203C28.7818 12.2471 29.5402 11.6186 30.0721 10.8143C30.604 10.01 30.8854 9.0661 30.8808 8.10186C30.8725 6.80974 30.3524 5.57358 29.4344 4.66419C28.5165 3.75479 27.2755 3.2463 25.9833 3.25009V3.25009Z",
    fill: "url(#paint1_linear_76_9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0064 23.1569C51.6073 24.0781 50.9085 24.4031 49.9112 24.3899C46.8987 24.3503 43.8853 24.3767 40.8719 24.3746C39.6389 24.3746 39.0061 23.7368 39.0061 22.4947C39.0061 19.4138 39.0061 16.333 39.0061 13.2522C39.0061 12.0009 39.6284 11.3753 40.8729 11.3753C43.8853 11.3753 46.8987 11.4017 49.9122 11.3611C50.9095 11.3469 51.6093 11.6658 52.0075 12.5941L52.0064 23.1569ZM48.734 14.6619H42.2968V21.0981H48.734V14.6619Z",
    fill: "url(#paint2_linear_76_9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00507702 22.3445C1.406 20.2143 2.80726 18.0849 4.20886 15.9561C4.99091 14.7708 5.78312 13.5916 6.57228 12.4104C7.46098 11.0799 8.79351 11.0728 9.67815 12.3921C11.7866 15.5386 13.8948 18.6871 16.0026 21.8377C16.1628 22.0732 16.2582 22.3466 16.2794 22.6306C16.3006 22.9146 16.2468 23.1992 16.1233 23.4559C15.9999 23.7125 15.8112 23.9322 15.5761 24.093C15.341 24.2537 15.0678 24.3498 14.7838 24.3718C14.5157 24.3941 14.2435 24.3809 13.9713 24.3809C10.0103 24.3809 6.04922 24.3606 2.09326 24.3951C1.09792 24.4032 0.396104 24.0904 0 23.1621L0.00507702 22.3445ZM11.5835 21.1135C10.4104 19.3544 9.2922 17.6756 8.13029 15.9276L4.67708 21.1135H11.5835Z",
    fill: "url(#paint3_linear_76_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_9",
    x1: 30.5981,
    y1: 17.7303,
    x2: 30.5981,
    y2: 52.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_9",
    x1: 26.0146,
    y1: 0,
    x2: 26.0146,
    y2: 16.2368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_9",
    x1: 45.5068,
    y1: 11.3606,
    x2: 45.5068,
    y2: 24.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_9",
    x1: 8.14195,
    y1: 11.4076,
    x2: 8.14195,
    y2: 24.3953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36ADD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3B8B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPlan);
export default __webpack_public_path__ + "static/media/select-plan.8f79320908178dbb27f62751adb2e8ff.svg";
export { ForwardRef as ReactComponent };